import { DashboardResponse } from '@com-delta-idp/mnx-oauth';
import { UserSession } from '../../models/common.interfaces';

export const getUserSession = (
  dashboardResponse: Partial<DashboardResponse> | undefined
): UserSession | undefined => {
  if (dashboardResponse && Object.keys(dashboardResponse).length > 0) {
    return adaptUserSession(dashboardResponse as DashboardResponse);
  }
  return undefined;
};

const adaptUserSession = (
  dashboardResponse: DashboardResponse
): UserSession => {
  return {
    enrollmentDate: dashboardResponse.enrollmentDate,
    firstName: dashboardResponse.firstName,
    is360Tier: dashboardResponse.is360Tier,
    isAbove18: dashboardResponse.isAbove18,
    lastName: dashboardResponse.lastName,
    loggedIn: dashboardResponse.loggedIn,
    medallionMbrInd: dashboardResponse.medallionMbrInd,
    medallionMemberDesc: dashboardResponse.medallionMemberDesc,
    membershipLevel: dashboardResponse.membershipLevel,
    middleName: dashboardResponse.middleName,
    millionMiler: dashboardResponse.millionMiler,
    millionMilerTier: dashboardResponse.millionMilerTier,
    skyPriority: dashboardResponse.skyPriority,
    skymilesMember: dashboardResponse.skymilesMember,
    smBalance: dashboardResponse.smBalance,
    smNumber: dashboardResponse.smNumber,
    cobrandCardtypeList: dashboardResponse.cobrandCardtypeList,
    countryCode: dashboardResponse.country,
    hasPhone: dashboardResponse.hasPhone,
    preferredName: dashboardResponse.preferredName,
    isSkyClubMember: dashboardResponse.isSkyClubMember,
    skyClubMemberType: dashboardResponse.skyClubMemberType,
    skyClubMembershipDiscontinueDate:
      dashboardResponse.skyClubMembershipDiscontinueDate,
    cobrandCardtypeAffiliationIdList:
      dashboardResponse.cobrandCardtypeAffiliationIdList,
    cobrandCardtypeDescList: dashboardResponse.cobrandCardtypeDescList,
    cobrandCardtypeSkyclubEligibleList:
      dashboardResponse.cobrandCardtypeSkyclubEligibleList,
    email: dashboardResponse.primaryEmailAddress,
    prefix: dashboardResponse.prefix,
    smeCompanyName: dashboardResponse.smeCompanyName
  };
};
